import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type TimelineTone = 'default' | 'primary' | 'success' | 'warning' | 'danger';

export interface TimelineItem {
  label: string;
  description?: string;
  time?: string;
  tone?: TimelineTone;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-timeline',
  styleUrl: './timeline.scss',
  templateUrl: './timeline.html',
})
export class TimelineComponent {
  /** Événements à afficher, du plus récent au plus ancien. */
  readonly items = input<TimelineItem[]>([]);
}
